module.exports = __webpack_public_path__ + "resource/img/image007Dark.57fa4eea.png";